module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921095334_T.549efccb.jpg";